import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import React from 'react'
import styled from 'styled-components'
import LoadingSpinner from './LoadingSpinner'
import PlyrVideo from './PlyrVideo'

dayjs.extend(relativeTime)

/*
 * The <ResponsiveVideo> component returns a <li> element and should be used inside an <ol> or <ul>
 * The component should receive an object: {...object} which contains:
 * * videoProvider
 * * link
 * * name (optional)
 * * duration (optional)
 */

/**
 * @example
 * <Videos> // a <ul> element
 *   {videos.map(({ node: video }) => (
 *     <ResponsiveVideo key={video.resource_key} {...video} />
 *   ))}
 * </Videos>
 */

const formatTime = unformattedSeconds => {
  const pad = function(num, size) {
    return ('000' + num).slice(size * -1)
  }
  const time = parseFloat(unformattedSeconds).toFixed(3)
  const hours = Math.floor(time / 60 / 60)
  const minutes = Math.floor(time / 60) % 60
  const seconds = Math.floor(time - minutes * 60)

  return `${pad(hours, 2) === '00' ? '' : `${pad(hours, 2)}:`}${pad(
    minutes,
    2
  )}:${pad(seconds, 2)}`
}

const VideoContainer = styled.li`
  position: relative;
  width: 100%;

  .contain-loading-spinner {
    pointer-events: none;
    background-color: ${props => props.theme.colors.nearlyWhite};
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc((100vw - 20px - 20px) * 0.5625);
    max-height: calc(850px * 0.5625);
    // (850 is the videos list container max width)
    width: 100%;
    opacity: 1;
    z-index: 3;
    /* top: 50%;
    left: 50%;
    transform: translate3D(-50%, -50%, 0); */
  }

  .plyr + .contain-loading-spinner {
    position: absolute;
    opacity: 0;
    transition: opacity 100ms ease 100ms;
  }

  .headline--small {
    margin-top: 14px;
    margin-bottom: 8px;
  }

  // HACKY – Fix vertical video (Tres Leches) issues
  /* .plyr__video-embed {
    > .plyr__video-embed__container {
      transform: translateY(-38.2812%) !important;

      iframe {
        height: calc((100vw - 20px - 20px) * 0.5625);
        max-height: calc(850px * 0.5625);
        top: 50% !important;
        transform: translateY(-50%);
      }
    }
  } */
`

const ResponsiveVideo = ({ videoProvider, link, ...props }) => {
  return (
    <VideoContainer>
      <PlyrVideo provider={videoProvider} src={link} />
      <div className="contain-loading-spinner">
        <LoadingSpinner className="loading-spinner" noText="true" />
      </div>
      {props.name && props.duration ? (
        <>
          <h4 className="headline--small">{props.name}</h4>
          <p className="detail">{formatTime(props.duration)}</p>
        </>
      ) : null}
      {props.children}
    </VideoContainer>
  )
}

export default ResponsiveVideo
